export default "__VITE_ASSET__V4WdNris__"